module.exports = __webpack_public_path__ + "static/dot-line--grey-c3728fdd74afb96070e82beddfcab233.svg";